/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Intelligence_LedeInputs */



/**
* | output |
* | --- |
* | "Colossus reads each week against your server's own normal, so a change shows up with what to do next and what your events did." |
*
* @param {Products_Intelligence_LedeInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_intelligence_lede = /** @type {((inputs?: Products_Intelligence_LedeInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Intelligence_LedeInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Colossus сравнивает каждую неделю с обычным ритмом вашего сервера. Изменение сразу видно — вместе с подсказкой, что делать дальше, и тем, что дали ваши события.")
	return /** @type {LocalizedString} */ ("Colossus reads each week against your server's own normal, so a change shows up with what to do next and what your events did.")
});